module.exports = ".iconeFolder {\r\n    color: #dada10;\r\n    font-size: 30px;\r\n}\r\n\r\n.iconeDownload {\r\n    color: #35a519;\r\n    font-size: 30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/documentos/documentos.component.css
// module id = ./src/app/documentos/documentos.component.css
// module chunks = main